<template>
  <label
    class="text"
    v-bind:class="rootClasses"
  >
    <span class="text__label">{{ title }}</span>
    <input
      class="text__input"
      data-lpignore="true"
      type="text"
      v-bind:inputmode="inputMode"
      v-bind:aria-invalid="hasViolations"
      v-bind:aria-label="ariaLabel"
      v-bind:autocomplete="autocomplete"
      v-bind:maxlength="maxlength"
      v-bind:name="name"
      v-bind:pattern="pattern"
      v-bind:placeholder="placeholder"
      v-bind:required="required"
      v-bind:readonly="readonly"
      v-bind:value="value"
      v-bind:disabled="disabled"
      v-on:input="onInput"
      v-on:invalid="onInvalid"
      v-on:blur="onBlur" />
    <p
      class="text__violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >{{ violationText }}</p>
  </label>
</template>
<script>
/**
 * @description Компонент ввода однострочного текста.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Имеет нарушения.
     * @type {boolean}
     */
    hasViolations() {
      return this.violations.length > 0;
    },
    /**
     * @description Список классов корневого элемента.
     * @type {string[]}
     */
    rootClasses() {
      const list = [];
      if (this.hasViolations) {
        list.push('invalid');
      }
      return list;
    },
  },
  methods: {
    /**
     * @description Обработать потерю фокуса.
     * @param {InputEvent} event Событие.
     * @param event
     */
    onBlur(event) {
      this.$emit('blur', event.target.value);
    },
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event Событие.
     * @returns {void}
     */
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    /**
     * @description Обработать провал проверки.
     * @param [...] args
     * @returns {void}
     */
    onInvalid(...args) {
      this.$emit('invalid', ...args);
    },
  },
  name: 'InputText',
  props: {
    /**
     * @description Автозаполнение.
     * @type {boolean|string}
     */
    autocomplete: { default: () => false, type: [String, Boolean] },
    /**
     * @description Описание элемента.
     * @type {string}
     */
    ariaLabel: { default: () => false, type: [String, Boolean] },
    /**
     * @description Максимальная длина.
     * @type {string|number}
     */
    maxlength: { default: () => false, type: [String, Number, Boolean] },
    /**
     * @description Регулярное выражение для проверки данных в поле.
     * @type {string}
     */
    pattern: { default: () => false, type: [String, Boolean] },
    /**
     * @description Уникальное имя элемента формы.
     * @type {String}
     */
    name: { default: () => false, type: [String, Boolean] },
    /**
     * @description Тип раскладки виртуальной клавиатуры.
     * @type {string}
     */
    inputMode: { default: () => 'text', type: String },
    /**
     * @description Поле обязательно для заполнения.
     * @type {boolean|string}
     */
    required: { default: () => false, type: [String, Boolean] },
    /**
     * @description Поле обязательно для чтения.
     * @type {boolean|string}
     */
    readonly: { default: () => false, type: Boolean },
    /**
     * @description Текст заполнитель.
     * @type {string}
     */
    placeholder: { default: () => false, type: [String, Boolean] },
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение.
     * @type {string}
     */
    value: { required: true, type: String },
    /**
     * @description Деактивирован
     * @type {Boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
<style lang="scss">
@use "@/scss/buttons";
@use "@/scss/fields";
.text {
  display: flex;
  flex-direction: column;
  &__label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 2px 0;
    color: var(--unfocus-color);
  }
  &__input {
    @include fields.input-field();
  }
  &.invalid .text__input{
    color: var(--warning-color);
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
}
.invalid {
  background: transparent !important;
}
</style>
